import './Main.scss';
import './Form/Form';
import 'Packages/Plugins/GesagtGetan.Inquiry/Resources/Public/JavaScript/SpamProtection';
